import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";
import zIndexTypes from "../../../theme/zIndexTypes";

export const JobOptionsButtonWrapper = styled.div`
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 68px;
  z-index: ${zIndexTypes.actionBarItem};
  background-color: ${(props) => (props.active === true ? "#fff" : "#79D9D9")};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-in-out;

  &:after {
    transition: 0.25s ease-in-out;
    content: "\f013";
    font-family: FontAwesome;
    font-size: ${(props) => (props.active === true ? "2em" : "1.5em")};
    color: ${(props) => (props.active === true ? "#402680" : "#fff")};
    transform: ${(props) =>
      props.active === true ? "rotate(90deg)" : "rotate(0deg)"};
  }

  &:hover,
  &:focus {
    background-color: #fff;
    color: #402680;

    &:after {
      color: #402680;
    }
  }

  ${mediaMaxWidth.tablet`
    right: 10px;
    top: 72px;
    width: 32px;
    height: 32px;

    &:after {
      font-size: ${(props) => (props.active === true ? "1.6em" : "1.4em")};
    }
  `}
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  border: 1px solid #bdbdbd;
  top: 52px;
  right: 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 3px #dcdcdc;

  &::after,
  &::before {
    bottom: 100%;
    right: 12px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #ffffff;
    border-width: 6px;
    margin-right: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #bdbdbd;
    border-width: 8px;
    margin-right: -2px;
  }

  ${mediaMaxWidth.tablet`
    top: 47px;
    right: -4px;
  `}
`;

export const DropdownList = styled.div`
  padding: 5px;
`;

export const DropdownListItem = styled.div`
  width: 160px;
  color: #333;
  border-radius: 4px;
  padding: 3px 0 3px 10px;
  font-weight: 500;
  font-size: 0.95em;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #79D9D9;
    color: #fff;
  }

  ${mediaMaxWidth.tablet`
    font-size: 0.9em;
  `}
`;
